import React from 'react';
import { Link, NavLink, Outlet } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import niceLogo from '../assets/logo-nice-header.svg';

export default function AppLayout() {
  const { user, logout } = useAuth();
  const canAccessFirmware = ['OWNER', 'SUPPORT_ADMIN', 'SUPPORT', 'FW_MANAGER', 'FW_ENGINEER'].includes(user?.activeRole);

  return (
    <div className="app-shell">
      <header className="app-header">
        <Link className="app-brand" to="/">
          <img className="app-brand-logo" src={niceLogo} alt="Nice" />
          <span>OneCloud Admin</span>
        </Link>
        <nav className="app-nav">
          <NavLink to="/" end>
            Dashboard
          </NavLink>
          {canAccessFirmware ? <NavLink to="/firmware">Firmware</NavLink> : null}
          <NavLink to="/users">Users</NavLink>
          <NavLink to="/settings">Profile</NavLink>
        </nav>
        <div className="app-user">
          <span className="app-user-email">{user?.email || user?.username || 'Signed in'}</span>
          <button className="btn btn-secondary" type="button" onClick={logout}>
            Sign out
          </button>
        </div>
      </header>
      <main className="app-main">
        <Outlet />
      </main>
    </div>
  );
}
